import React, { createContext, useContext, useMemo, useState } from "react";

interface INotification {
    assunto: string;
    mensagem: string;
}

interface INotificationContextData {
    notifications: INotification[];
    setNotifications: (notifications: INotification[]) => void;
}

const NotificationContext = createContext<INotificationContextData>({
    notifications: [],
    setNotifications: () => {},
});

export function useNotification(): INotificationContextData {
    return useContext(NotificationContext);
}

interface NotificationProviderProps {
    children: React.ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
    children,
}) => {
    const [notifications, setNotifications] = useState<INotification[]>([]);

    const contextValue = useMemo(() => {
        return { notifications, setNotifications };
    }, [notifications]);

    return (
        <NotificationContext.Provider value={contextValue}>
            {children}
        </NotificationContext.Provider>
    );
};
